module.exports = __webpack_public_path__ + "static/img/auth-illustration.35821b6c.png";